import React, { useMemo } from 'react';
import { alpha, Icon, ListItem, ListItemText } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import IntlMessages from '../../../../utility/IntlMessages';
import Box from '@mui/material/Box';
import AppNavLink from '../../../AppNavLink';
import Badge from '@mui/material/Badge';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import { useLocation } from 'react-router-dom';
import { useAuthUser } from '@crema/utility/AuthHooks';
import { checkPermission } from '@crema/utility/helper/RouteHelper';
import * as Icons from '@mui/icons-material';
import { COLORS } from 'shared/constants/AppEnums';

const checkAccess = (userRoles, menuRoles) => {
  let permit = false;
  for (const value of menuRoles) {
    if (userRoles.includes(value)) {
      permit = true;
      break;
    }
  }
  return permit;
};

function HorizontalItem(props) {
  const { item, dense } = props;
  const { user } = useAuthUser();
  const location = useLocation();
  const active = isUrlInChildren(item, location.pathname);
  const { sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor } =
    useSidebarContext();

  const hasPermission = useMemo(
    () => checkPermission(item.permittedRole, user.role),
    [item.permittedRole, user.role],
  );
  if (!hasPermission) {
    return null;
  }

  if (user.roles_access.includes('CRSFE_ADMIN_PENOMORAN')) {
    if (item.id === 'app-portal') return null;
  }

  if (item.role_access && !item.id.includes('app-produk-hukum')) {
    const roleAccess = checkAccess(user.roles_access, item.role_access);
    if (!roleAccess) return null;
  }

  function isUrlInChildren(parent, url) {
    if (!parent.children) {
      return false;
    }

    for (let i = 0; i < parent.children.length; i++) {
      if (parent.children[i].children) {
        if (isUrlInChildren(parent.children[i], url)) {
          return true;
        }
      }

      if (
        parent.children[i].url === url ||
        url.includes(parent.children[i].url)
      ) {
        return true;
      }
    }

    return false;
  }

  const handleClick = (url) => {
    if (url === '/apps/KnowledgeManagement') {
      sessionStorage.setItem("reloadLiniMasa", true);
    }
    if (item.isNewWindow === '1') {
      window.open(item.url);
    }
  };

  let toProps = {
  }

  let nip_login = user.nip;
  let email_login = user.email;
  if (item.isNewWindow !== '1' && item.isAction !== '1') toProps.to = item.url;
  if (item.id === 'app-admintools') toProps.to = '/apps/admintools/employee';
  if ((item.id === 'app-admintools') && (user.roles_access.includes('CRSFE_ADMIN_PENOMORAN'))) toProps.to = '/apps/admintools/penomoran';
  if (item.id === 'app-portal') toProps.to = '/kkp';
  if (item.id === 'app-repository') item.url += '&nip_login=' + nip_login + '&email_login=' + email_login + '&keycloak_id=keycloack-' + user.keycloack_id;
  if (item.id === 'chat') item.url += '&nip_login=' + nip_login + '&email_login=' + email_login + '&keycloak_id=keycloack-' + user.keycloack_id;

  const IconComponent = Icons[item?.icon];

  return (
    <ListItem
      component={AppNavLink}
      id={item.id}

      activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : 'active'}
      className={clsx('navItemSubmenu', dense && 'dense')}
      exact={item.exact}
      onClick={() => handleClick(item.url)}
      {...toProps}
      sx={{

        minHeight: 40,
        padding: '4px 12px',
        // paddingLeft: item.id === 'dashbor-lpmukp' ? '3rem !important' :'' ,
        color: (theme) => theme.palette.text.primary,
        textDecoration: 'none!important',
        minWidth: 160,
        '&.active': {
          // backgroundColor: sidebarMenuSelectedBgColor,
          // color: sidebarMenuSelectedTextColor + '!important',
          backgroundColor: `${alpha(COLORS.primary, 0.2)} !important`,
          color: `${COLORS.primary} !important`,
          pointerEvents: 'none',
          '& .list-item-text-primary': {
            color: 'inherit',
          },
          '& .list-item-icon': {
            color: 'inherit',
          },
        },
        '& .list-item-text': {
          padding: '0 0 0 16px',
        },
        '& #dashbor-lpmukp': {
          paddingLeft: "3rem"
        },
        '&.dense': {
          padding: '4px 12px',
          minHeight: 40,
          '& .list-item-text': {
            padding: '0 0 0 8px',
          },
        },
      }}
    >
      {item.icon && (
        <Icon
          sx={{
            color: active ? COLORS.primary : 'action',
            mr: 3,
            fontSize: { xs: 16, xl: 18 },
          }}
        >
          <IconComponent sx={{ fontSize: '20px' }} />
        </Icon>
      )}
      <ListItemText
        className='AppNavLinkTextSubmenu'
        primary={item.messageId}
      />
      {item.count && (
        <Box ml={4}>
          <Badge
            count={item.count}
            sx={{
              color: item.color,
            }}
          />
        </Box>
      )}
    </ListItem>
  );
}

HorizontalItem.defaultProps = {};

export default React.memo(HorizontalItem);

HorizontalItem.propTypes = {
  item: PropTypes.object,
  location: PropTypes.object,
  dense: PropTypes.bool,
};
